import { render, staticRenderFns } from "./thirdparty.vue?vue&type=template&id=03020c6f&scoped=true&"
import script from "./thirdparty.vue?vue&type=script&lang=js&"
export * from "./thirdparty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03020c6f",
  null
  
)

export default component.exports